import { useEffect, useRef, ReactElement } from "react";

import {
    RootStateKind,
    useAnyState,
    WelcomeSubStateKind
} from "./state/StateProvider";
import { LogClient } from "../clients/LogClient";
import { httpClient } from "../utils/http";

export const VersionController = ({ children }: { children: ReactElement }) => {
    const minutesUntilNextRefresh = 5;

    const logClient = new LogClient(httpClient);

    const { state } = useAnyState();
    const lastUpdate = useRef(new Date());

    useEffect(() => {
        const remainingTime =
            lastUpdate.current.valueOf() +
            minutesUntilNextRefresh * 60 * 1000 -
            new Date().valueOf();

        const id = setTimeout(
            () => {
                if (
                    state.kind === RootStateKind.OutOfOrder ||
                    (state.kind === RootStateKind.Welcome &&
                        state.subState.kind === WelcomeSubStateKind.Idle)
                ) {
                    logClient
                        .info("VersionController reset. Reloading window")
                        .then(() => window.location.reload());
                }
            },
            Math.max(0, remainingTime)
        );

        return () => clearTimeout(id);
    }, [state]);

    return children;
};
